const PRODUCT_NAME = 'Tamr';

export default PRODUCT_NAME;
